/**
 * created by li si yi
 * 新媒体矩阵-微信榜单
 * */
import React, {Component} from 'react';
import {message, Button, Card, Select, Tabs, Radio} from 'antd';
import star from './image/star.png';
import moment from 'moment'
import {Scrollbars} from "react-custom-scrollbars";
import {setInfoToLocalStorage, getInfoFromLocalStorage, removeInfoFromLocalStorage} from "../../../../actions"
import { request } from '@cm-sites-webber/components';
import TableTemplate from "../../components/TableTemplate/TableTemplate";
import PageTemplate from "../../components/pageTemplate/PageTemplate";
import {uuid} from "../../../../utils";
// import *as Action from "../../actions/horizontalManagement";

const {Option} = Select;
const {TabPane} = Tabs

class MediaMatrixNewList extends Component {
    constructor(props) {
        super(props);
        // this.Actions = Action;
        this.state = {
            btnList: [
                {
                    title: '日榜',
                    key: "1"
                },
                {
                    title: '周榜',
                    key: "2"
                },
                {
                    title: '月榜',
                    key: "3"
                },
                {
                    title: '年榜',
                    key: "4"
                },
                {
                    title: '自定义榜单',
                    key: "5"
                },
            ],
            dataSource: [],
            thisBtn: "1",
            selectYear: new Date().getFullYear(),
            selectMonth: new Date().getMonth() + 1,
            selectedDate: null
        }
    }

    componentDidMount() {
        let params = getInfoFromLocalStorage("NewMediaMatrixList");
        if (params) {
            this.setState({thisBtn: params.listType},()=>{
                removeInfoFromLocalStorage("NewMediaMatrixList")
                setTimeout(()=>{
                    // 对于其他选项，调用getDays函数
                    this.getDays();
                },300)
            })
        }else {
            this.getDays();
        }
    }

    // 获取日期接口
    getDays = () => {
        let body = {year: this.state.selectYear, month: this.state.selectMonth, type: this.state.thisBtn};
        request({
            url: "/cm-sites-media-consumer/contentManager/getDays",
            body,
            contentType: "json",
            callBack:(response)=>{
                let Data = response;
                if (Data && Data.length > 0) {
                    this.setState({dataSource: Data});
                } else {
                    this.setState({dataSource: []});
                }
            },
            errorCallBack: (err)=> {
                // reject(err)
                message.error(err);
            }
        })
    };
    // 日榜按钮
    renderTabs = () => {
        let {btnList, thisBtn} = this.state;
        return (
            <div style={{marginBottom: '5px'}}>
                <Tabs defaultActiveKey={thisBtn} className='media-matrix-new-list-tabs' tabBarStyle={{padding: "0 32px"}} activeKey={thisBtn} onChange={(e) => {
                        this.setState({thisBtn: e},()=>{
                            if (e === "5") {
                                // 自定义榜单 设置当天时间
                                setInfoToLocalStorage("mediaMatrixNewList", {
                                    startTime: moment().subtract(1,'month').startOf('months'),
                                    endTime: moment().subtract(1,'month').endOf('months'),
                                    listType: e,
                                });
                                this.props.showFun && this.props.showFun()
                            } else {
                                setTimeout(()=>{
                                    // 对于其他选项，调用getDays函数
                                    this.getDays();
                                },300)
                            }
                        })
                }}>
                    {btnList.map((item) => (
                        <TabPane tab={item.title} key={item.key}/>
                    ))}
                </Tabs>
            </div>
        )
    };

    // 日期选择
    renderDateSelect = () => {
        return (
            <div style={{marginBottom: 20,padding: "0 32px",height: "32px"}}>
                {
                    this.state.thisBtn === "1" ? this.renderDay() : this.state.thisBtn === "2" ? this.renderWeekOrMonth() : this.state.thisBtn === "3" ? this.renderWeekOrMonth() : null
                }
            </div>
        )
    };
    // 日榜月份循环
    renderDayMonth = () => {
        const months = Array.from({ length: 12 }, (_, i) => i + 1);
        const { selectMonth } = this.state;
        // let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        const monthList = months.map((month, index) => {
            const isSelected = selectMonth === month;
            const isFirst = index === 0;
            const isLast = index === months.length - 1;

            const monthStyle = {
                fontWeight: 700,
                cursor: 'pointer',
                color: isSelected ? '#0050b3' : '',
                width: '50px',
                textAlign: 'center',
                // border: isSelected ? '1px solid `$(newSecondSelectColor)`' : '1px solid #D9D9D9',
                lineHeight: '30px',
                borderRadius: isFirst ? '5px 0 0 5px' : isLast ? '0 5px 5px 0' : null,
            };


                // <div
                //     key={month.toString()}
                //     style={monthStyle}
                //     onClick={() => {
                //         this.setState({ selectMonth: month }, () => {
                //             this.getDays();
                //         });
                //     }}
                // >
                //     {month}月
                // </div>


        });
        return (

            <Radio.Group value={this.state.selectMonth}
                         style={{marginRight: '10px'}} onChange={this.handleSizeChange}>
                {months && months.length && months.map((item, index) => {
                    return (<Radio.Button value={item} key={index}>{item}月</Radio.Button>)
                })}
            </Radio.Group>);


    };
    handleSizeChange = e => {

        this.setState({ selectMonth: e.target.value }, () => {
                        this.getDays();
                    });
    };


    // 日榜年份循环
    renderDayYear = () => {
        const endYear = new Date().getFullYear();
        const startYear = 2022;
        const yearList = this.generateYearList(startYear, endYear);
        return yearList;
    };
    // 日榜
    renderDay = () => {
        const yearList = this.renderDayYear();
        return (
            <div style={{display: 'flex', alignItems: 'center'}}>
                <Select defaultValue={this.state.selectYear.toString()}
                        style={{width: 100, marginRight: 15}}
                        onChange={(e) => {
                            this.setState({selectYear: e}, () => {
                                this.getDays();
                            })
                        }}>
                    {
                        yearList.map((year) => (
                            <Option value={year} key={year}>
                                {year}
                            </Option>
                        ))
                    }
                </Select>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '30px',
                }}>
                    {this.renderDayMonth()}
                </div>
            </div>
        )
    };
    // 年份选择
    generateYearList = (startYear, endYear) => {
        const yearList = [];
        for (let year = startYear; year <= endYear; year++) {
            yearList.push(year.toString());
        }
        return yearList;
    };
    // 周榜
    renderWeekOrMonth = () => {
        const yearList = this.renderDayYear();
        return (
            <div style={{display: 'flex'}}>
                {
                    yearList.map((year) => (
                        <div key={year}
                             style={{
                                 marginRight: 15,
                                 color: this.state.selectYear.toString() === year ? 'rgb(24, 144, 255)' : "",
                                 cursor: 'pointer',
                             }}
                             onClick={() => {
                                 this.setState({selectYear: year}, () => {
                                     this.getDays();
                                 })
                             }}>{year}年
                        </div>
                    ))
                }
            </div>
        )
    };

    // 点击跳转对应日期
    handleClick = (selectedType, item) => {
        // console.log(item);
        let startTime = null;
        let endTime = null;
        let selectedDate = null;
        if (!item) return false;
        if (selectedType === "1") {
            let dateStr = item.timeStr;
            if (!dateStr) return false;
            let [year, month, day] = dateStr.split("-");

            startTime = new Date(`${year}-${month}-${day}T00:00:00`).getTime();
            endTime = new Date(`${year}-${month}-${day}T23:59:59`).getTime() + 1000;
        } else if (selectedType === "2") {
            let [startDateStr, endDateStr] = item.timeStr.split("~");

            if (!startDateStr && !endDateStr) return false;
            let [startYear, startMonth, startDay] = startDateStr.split("-");
            startTime = new Date(`${startYear}-${startMonth}-${startDay}T00:00:00`).getTime();
            let [endYear, endMonth, endDay] = endDateStr.split("-");
            endTime = new Date(endYear, endMonth-1, endDay, 23, 59, 59, 999).getTime();
        } else if (selectedType === "3") {
            const  dateStr= item.timeStr;
            if (!dateStr) return false;
            let [year, month] = dateStr.split("-");
            const startDate = new Date(year, month - 1, 1);
            const endDate = new Date(year, month, 0);

            // 获取startDate的00:00:00的时间戳
            startTime = startDate.getTime();
            // 获取endDate的23:59:59的时间戳
            endTime = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 999).getTime();
        } else if (selectedType === "4") {
            const year = parseInt(item.timeStr, 10);
            startTime = new Date(year, 0, 1).getTime();
            endTime = new Date(year, 11, 31, 23, 59, 59, 999).getTime();
        }
        selectedDate = {startTime: startTime, endTime: endTime, listType: selectedType.toString()};
        // console.log(selectedDate);
        // this.props.history.push({
        //     // pathname: '/view/newMediaMatrix/list',
        //     state: selectedDate,
        // });
        setInfoToLocalStorage("mediaMatrixNewList", selectedDate);
        this.props.showFun && this.props.showFun()
    };

    // 卡片
    renderCard = () => {
        let {dataSource, selectYear, thisBtn} = this.state;

        const columns = [{
            dataIndex: 'mediaAccountName',
            title: '排名',
            ellipsis: true,
            render: (text, record, index) => {
                return <div>{index+1}</div>
            }
        },{
            dataIndex: 'mediaName',
            title: '账号名称',
            ellipsis: true
        },{
            dataIndex: 'index',
            title: '综合指数',
            ellipsis: true
        }];

       let data = [{
           type:"1",
           text:'微信日榜'
       },
           {
               type:"2",
               text:'微信周榜'
           },
           {
               type:"3",
               text:'微信月榜'
           },
           {
               type:"4",
               text:'微信年榜'
           }];
       let newData = data.filter(item => item.type === thisBtn)
        let newSecondSelectColor =window.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3");

        return (
            <div className={'flex-container'} style={{padding: "0 32px"}}>
                {
                    dataSource && dataSource.map((item, index) => {
                        return (
                            <div className={'flex-item'} key={index} >
                                <Card
                                    style={{width: 376,
                                        height: '384px',
                                        overflow: 'hidden'}}
                                    bodyStyle={{padding:0}}
                                >
                                    <div style={{position:'relative'}}>

                                        <img src={'images/media/backgroundImg.jpg'} style={{width:'100%'}} />
                                        <div style={{position:'absolute',top:18,left:24}}>
                                            <div style={{fontWeight: 700,
                                                fontSize: '18px'}}>{newData[0]?.text}</div>
                                            <div style={{marginTop:5}}>{item.timeStr}</div>
                                        </div>
                                    </div>

                                <PageTemplate style={{padding:'0',height:220}}>
                                    <TableTemplate
                                        columns={columns}
                                        dataSource={item.childList}
                                        onResize={(offsetHeight) => {
                                            if (this.tableHeaderHeight != offsetHeight) {
                                                this.tableHeaderHeight = offsetHeight;
                                                this.setState({});
                                            }
                                        }}
                                    />
                                </PageTemplate>
                                    <div style={{
                                        height: '50px',
                                        lineHeight: '50px',
                                        textAlign: 'center',
                                        fontWeight: 700,
                                        borderTop: '1px solid #e0e0e0',
                                        cursor: "pointer",
                                        fontSize: '14px',
                                       color:newSecondSelectColor
                                    }} onClick={() => {
                                        this.handleClick(thisBtn, item)
                                    }}>生成榜单
                                    </div>

                                    {/*<div style={{*/}
                                    {/*    display: 'flex',*/}
                                    {/*    flexDirection: 'column',*/}
                                    {/*    justifyContent: 'space-around',*/}
                                    {/*    alignItems: 'center',*/}
                                    {/*    height: 200,*/}
                                    {/*}}>*/}

                                    {/*    <img src={star} style={{width: 70}}/>*/}
                                        {/*{*/}
                                        {/*    thisBtn === "2" ? <div*/}
                                        {/*        style={{fontWeight: 700}}>{selectYear}年第{index + 1}周微信榜单</div> : null*/}
                                        {/*}*/}
                                        {/*/!*<div style={{fontWeight: 700}}>{item}</div>*!/*/}
                                        {/*{*/}
                                        {/*    thisBtn === "1" ? <div*/}
                                        {/*        style={{fontWeight: 700,color:'#262626'}}>微信日榜</div> : thisBtn === "3" ? <div*/}
                                        {/*        style={{fontWeight: 700,color:'#262626'}}>微信月榜</div> : thisBtn === "4" ? <div*/}
                                        {/*        style={{fontWeight: 700,color:'#262626'}}>微信年榜</div> : null*/}
                                        {/*}*/}

                                    {/*</div>*/}
                                </Card>
                            </div>
                        )
                    })
                }
                <style>{`
                .flex-container {
                   display:grid;
                   grid-gap: 24px;
                   grid-template-columns:repeat(auto-fill, 376px)
                }
                .flex-item {
                  margin-bottom: 20px;
                  margin-right: 20px;
                }
                .flex-item:last-child {
                  margin-right: 0;
                }
                .flex-container .ant-table-placeholder{border-bottom:none !important}
                `}</style>
            </div>
        )
    };

    render() {
        return (
            <div style={{
                background: '#fff',
                borderRadius: '5px',
                margin: '15px 0',
                // padding: '0 32px',
                maxHeight: 'calc(100vh - 100px)'
            }}>
                {this.renderTabs()}
                {this.renderDateSelect()}
                <Scrollbars autoHeight autoHide autoHeightMax={"calc(100vh - 220px)"}>
                    {this.renderCard()}
                </Scrollbars>
            </div>
        );
    }
}

export default MediaMatrixNewList;